import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { Icon } from '@iconify/react';

interface Props {
  open: boolean;
  email: string;
  onClose: () => void;
}

const ConfirmationSent: React.FC<Props> = ({ open, email, onClose }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: '#E7ECF2',
          borderRadius: '12px',
          width: '100%',
        },
      }}
    >
      <IconButton
        aria-label="Close"
        onClick={onClose}
        sx={{
          position: 'absolute',

          top: '12px',
          right: '12px',
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            width: '18px',
            height: '18px',
            backgroundImage: 'url("/assets/onBoarding/x.svg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      </IconButton>

      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: '400px', width: '100%' }}
        >
          <Stack spacing={2} alignItems="center">
            <img
              src="/assets/onBoarding/mailSent.svg"
              alt="Mail Sent"
              style={{ width: '150px', height: '150px' }}
            />
            <Typography
              dir="rtl"
              fontWeight={900}
              fontSize="18px"
              fontFamily="AlmoniDL"
            >
              היי, שלחנו לך לינק אימות למייל!
            </Typography>
            <Stack alignItems="center">
              <Typography
                fontWeight={700}
                dir="rtl"
                fontSize="14px"
                fontFamily="AlmoniDL"
                sx={{
                  ...(isMobile && { textAlign: 'right' }),
                  maxWidth: '500px',
                  textAlign: 'center',
                  mb: '15px',
                }}
              >
                כדי להשלים את תהליך ההרשמה ולהתחיל לקבל מאיתנו הודעות לחצו על
                הלינקים שנשלחו אליכם.
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </DialogContent>

      <Box
        sx={{
          width: '100%',
          height: '55px',
          backgroundColor: '#343434',
          marginTop: 'auto',
          direction: 'rtl',
          display: 'flex',
        }}
      >
        <Stack direction="row" gap={1} alignItems="center" px={1}>
          <img
            src="/assets/onBoarding/info.svg"
            alt="Info"
            style={{ width: '30px', height: '30px' }}
          />
          <Stack>
            <Typography
              fontWeight={700}
              fontSize="14px"
              fontFamily="AlmoniDL"
              color="#FFF"
            >
              לא מוצאים את המייל?
            </Typography>
            <Typography
              fontWeight={700}
              fontSize="14px"
              fontFamily="AlmoniDL"
              color="#FFF"
            >
              בדקו בתיבת הספאם או חפשו את השולח no-reply@pielapay.co.il
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ConfirmationSent;
